import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../../components/notifications';
import api from '../../../libs/api';

const initialState = {
  sets: [],
  set: {},
  setIds: [],
};

export const addSet = createAsyncThunk('dropdowns/sets/addSet', async data => {
  const { data: set } = await api.post('/dropdowns/machine-sets', data);

  return set;
});

export const editSet = createAsyncThunk(
  'dropdowns/sets/editSet',
  async ({ id, data }) => {
    const { data: set } = await api.put(`/dropdowns/machine-sets/${id}`, data);

    return set;
  },
);

export const getSets = createAsyncThunk('dropdowns/sets/getSets', async () => {
  const { data } = await api.get(`/dropdowns/machine-sets`);

  return data;
});

export const getSetIds = createAsyncThunk(
  'dropdowns/sets/getSetIds',
  async () => {
    const { data } = await api.get(`/dropdowns/machine-sets/ids`);

    return data;
  },
);

export const getSet = createAsyncThunk('dropdowns/sets/getSet', async id => {
  const { data } = await api.get(`/dropdowns/machine-sets/${id}`);

  return data;
});

const sets = createSlice({
  name: 'sets',

  initialState,

  reducers: {
    clearSets: draft => {
      draft.sets = initialState.sets;
    },

    clearSet: draft => {
      draft.set = initialState.set;
    },

    clearSetIds: draft => {
      draft.setIds = initialState.setIds;
    },
  },

  extraReducers: builder => {
    builder.addCase(addSet.fulfilled, (draft, { payload }) => {
      draft.sets.push(payload);
    });

    builder.addCase(editSet.fulfilled, (draft, { payload }) => {
      const index = draft.sets.findIndex(el => el.id === payload.id);

      draft.sets[index] = payload;
    });

    builder.addCase(getSets.fulfilled, (draft, { payload }) => {
      draft.sets = payload;
    });

    builder.addCase(getSet.fulfilled, (draft, { payload }) => {
      draft.set = payload;
    });

    builder.addCase(getSetIds.fulfilled, (draft, { payload }) => {
      draft.setIds = payload;
    });

    builder.addMatcher(
      isAnyOf(
        addSet.rejected,
        editSet.rejected,
        getSets.rejected,
        getSet.rejected,
        getSetIds.rejected,
      ),
      (_draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearSet, clearSets, clearSetIds } = sets.actions;

export default sets.reducer;
